/**
 * Bir sayıyı `multipart/form-data` gövdesine yazmak için biçimlendirir.
 *
 * Tutarlar tel üzerinde kanonik (culture-bağımsız) biçimde taşınır: ondalık ayırıcı her zaman
 * "." ve binlik ayırıcı yoktur. Backend, form-data ondalıklarını InvariantCulture ile çözümler
 * (bkz. InvariantDecimalModelBinder), bu yüzden istek locale'inden (Accept-Language) bağımsızdır.
 * JS `String(number)` zaten locale'den bağımsız olarak "123.56" üretir — dönüşüme gerek yoktur.
 *
 * JSON gövdeleri de aynı şekilde kültürden bağımsız çözümlenir.
 */
export function formatDecimalForFormData(value: number | null | undefined): string {
  return String(value ?? 0);
}
